import { Report197Container } from "../../../containers/borrowSystem/Report/Report197Container";

export function Report197Page() {
    return (
        <Report197Container />
    )
}